import { useState, type ReactNode } from 'react'
import styles from '@/lib/markdown.module.css'

export function Spoiler({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  return (
    <button type="button" className={open ? styles.spoilerOpen : styles.spoiler} onClick={() => setOpen(true)} aria-label={open ? undefined : 'Показать спойлер'}>
      <span>{children}</span>
    </button>
  )
}
